import { environment } from '@env/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class SuggestionService {
    constructor(http) {
        this.http = http;
    }
    get(per_page = 10, page = 1, by_user) {
        return this.http.get(`${environment.base_url}/suggestion?page=${page}&per_page=${per_page}&by_user=${by_user}`);
    }
    delete(id) {
        return this.http.delete(`${environment.base_url}/suggestion/${id}`);
    }
    saveAnswer(data) {
        return this.http.post(`${environment.base_url}/suggestion/save_answer`, data);
    }
    update(id, form) {
        return this.http.put(`${environment.base_url}/suggestion/${id}`, form);
    }
}
SuggestionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SuggestionService_Factory() { return new SuggestionService(i0.ɵɵinject(i1.HttpClient)); }, token: SuggestionService, providedIn: "root" });
